"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = exports.articleInformationPropType = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var articleInformationPropType = _propTypes["default"].shape({
  sectionHeading: _propTypes["default"].string,
  paragraph: _propTypes["default"].string,
  readTime: _propTypes["default"].string,
  categoryNames: _propTypes["default"].array
});
exports.articleInformationPropType = articleInformationPropType;
var PROP_TYPES = _propTypes["default"].shape({
  resourceType: _propTypes["default"].string,
  enableArticleDate: _propTypes["default"].bool,
  enableReadTime: _propTypes["default"].bool,
  showCategoryTag: _propTypes["default"].bool,
  articleAuthor: _propTypes["default"].string,
  theme: _propTypes["default"].string,
  date: _propTypes["default"].string,
  articleInformation: articleInformationPropType
});
var _default = PROP_TYPES;
exports["default"] = _default;